import { render, staticRenderFns } from "./user_link_with_tooltip.vue?vue&type=template&id=b417120e"
import script from "./user_link_with_tooltip.vue?vue&type=script&lang=js"
export * from "./user_link_with_tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports